<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else-if="!this.loading && !this.errormessage">
      <div class="row mt-3">
        <div class="col-md-6">
          <budget-summary
            :budget-info="budgetInfo"
            :cell-style="cellStyle"
            :header-cell-style="headerCellStyle"
          />
        </div>
        <budget-statistics
          :budget-info="budgetInfo"
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
        />
      </div>
      <budget-details
        :editable="true"
        :budget-info="budgetInfo"
        @budget-updated="budgetUpdated"
        @details-updated="detailsUpdated"
      />
    </div>
  </div>
</template>

<script>
import budgetApi from '@/services/api/budget.js'
import BudgetSummary from '@/components/finance/budget-summary.vue'
import BudgetStatistics from '@/components/finance/budget-statistics.vue'
import BudgetDetails from '@/components/finance/budget-details.vue'

export default {
  name: 'Budget',
  components: {
    BudgetSummary,
    BudgetStatistics,
    BudgetDetails
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: { padding: '0', height: '20px', 'font-size': '10px', 'overflow-wrap': 'break-word' },
      budgetInfo: {
        Budget: {}
      },
      loading: true,
      errormessage: null,
      scouterEstimate: {
        show: false,
        participants: null,
        staff: null
      },
      showEditItem: false,
      editItem: {},
      tempHolding: null
    }
  },
  mounted  () {
    this.getBudgetInfo()
  },
  methods: {
    budgetUpdated: function (newBudget) {
      this.budgetInfo = newBudget
    },
    detailsUpdated: function () {
      this.getBudgetInfo()
    },
    getBudgetInfo: function () {
      budgetApi.getBudgetWithActuals(this.$root.courseKey)
        .then(x => {
          this.budgetInfo = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
